import React from 'react';

import { useUserAccountData } from '../../hooks/useUserAccountData';

import { DirectEngagementsForm } from './DirectEngagementsForm';

export const DirectEngagements = () => {
  const { account, user } = useUserAccountData();
  return <DirectEngagementsForm account={account} user={user} />;
};
